import i18n from '@ohif/i18n';
import { message } from 'antd';

const TOAST_NS = 'Toast';
const NOTIFICATIONS_NS = 'Notifications';

type ToastOptions = Record<string, unknown>;

/** Translate a Toast namespace key (usable outside React components). */
export function tToast(key: string, options?: ToastOptions): string {
  return i18n.t(key, { ns: TOAST_NS, ...options });
}

/** Translate a Notifications namespace key (usable outside React components). */
export function tNotifications(key: string, options?: ToastOptions): string {
  return i18n.t(key, { ns: NOTIFICATIONS_NS, ...options });
}

/** Translated Ant Design message notifications (preferred over react-toastify). */
export const messageI18n = {
  success: (key: string, options?: ToastOptions, duration?: number) =>
    message.success(tToast(key, options), duration),
  error: (key: string, options?: ToastOptions, duration?: number) =>
    message.error(tToast(key, options), duration),
  warning: (key: string, options?: ToastOptions, duration?: number) =>
    message.warning(tToast(key, options), duration),
  info: (key: string, options?: ToastOptions, duration?: number) =>
    message.info(tToast(key, options), duration),
};
